/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { BrowserModule, Title } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { DeviceDetectorService } from "ngx-device-detector";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthFeatureModule } from "./features/auth-feature/auth-feature.module";
import { NgHttpLoaderModule } from "ng-http-loader";
import { LoaderComponent } from "./shared/loader/loader.component";
import { RouterModule } from "@angular/router";
import { Interceptor } from "./interceptor";
import { UserModule } from "./features/user/user.module";
import { CheckUrlComponent } from "./shared/check-url/check-url.component";
import { ToastrModule } from "ngx-toastr";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { HeaderComponent } from "./shared/header/header.component";
import { FooterComponent } from "./shared/footer/footer.component";
import { UserService } from "valuchaincommon/common-services/user/user.service";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { ViewImagesComponent } from "./shared/view-images/view-images.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { isJDXHomePage } from "src/environments/config";
import { DatePipe, CurrencyPipe, DecimalPipe } from "@angular/common";
import { EmbedVideo } from "ngx-embed-video";
import { AppCustomPreloader } from "./custom/custom-preloader";
import { CustomBreakPointsProvider } from "./custom/custom-breakpoints";
import { BrowserValidationModule } from "./features/browser-validation/browser-validation.module";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { NgxImageCompressService } from "ngx-image-compress";
import { NotificationsModule } from "./features/notifications/notifications.module";
import { MatDividerModule } from "@angular/material/divider";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";

@NgModule({
  declarations: [
    AppComponent,
    LoaderComponent,
    CheckUrlComponent,
    HeaderComponent,
    FooterComponent,
    ViewImagesComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    MatIconModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthFeatureModule,
    MatBottomSheetModule,
    FlexLayoutModule,
    UserModule,
    MatMenuModule,
    MatDividerModule,
    NgHttpLoaderModule.forRoot(),
    RouterModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    ToastrModule.forRoot(),
    EmbedVideo.forRoot(),
    BrowserAnimationsModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    ToastrModule.forRoot(),
    BrowserValidationModule,
    NotificationsModule,
    BsDropdownModule.forRoot(),
  ],
  providers: [
    DeviceDetectorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: isJDXHomePage.flag ? "en-US" : "en-GB",
    },
    UserService,
    Title,
    DatePipe,
    DecimalPipe,
    CurrencyPipe,
    AppCustomPreloader,
    NgxImageCompressService,
    CustomBreakPointsProvider,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
